import {
    changeActiveWheels, changeCutType, changeIsRunflat,
    changeRadius,
    changeWheelDiskType, setCutType,
    setIsActive, setIsRunflat,
    setRadius,
    setWheelDiskType
} from './constants'
import axios from '../../../plugins/axios-common'

export default {
    namespaced: true,
    state: {
        isFirstTab: false,
        harenessPrice: 250, // стоимость жгута
        cameraRepairPrice: 150, // стоимость починки камеры
        costumerDiscount: 12,
        url: '/calc/',
        availableTire: [], // заполняется при загрузке из jsona
        cutTypeList: ['Боковой', 'Плечевой', 'Беговой'],
        tyreRepairs: [],
        extraDiameters: [], // данные по радиусам дисков из json
        QRcodeUrl: '/QR.png',
        selected: {
            forwardLeft: null,
            forwardRight: null,
            backLeft: null,
            backRight: null,
            spareLeft: null,
            spareRight: null,
        },
        wheels:{
            forwardLeft: {
                isActive: false,
                data: {},
            },
            forwardRight: {
                isActive: false,
                data: {},

            },
            backLeft: {
                isActive: false,
                data: {},

            },
            backRight: {
                isActive: false,
                data: {},
            },
            spareLeft: {
                isActive: false,
                data: {},
            },
            spareRight: {
                isActive: false,
                data: {},
            },
        },
    },
    mutations: {
        setIsFirstTab (state, value) {
            state.isFirstTab = value
        },
        addData (state, payload) {
            const {value, side} = payload
            state.wheels[side].data = JSON.parse(JSON.stringify(value))
        },
        [setRadius](state, payload) {
            state.selected[side] = null
            const {value, side} = payload
            state.wheels[side].data.radius = value
        },
        setRadiusRate(state, payload) {
            const {value, side} = payload
            state.wheels[side].data.radiusRate = value
        },
        setSelected(state, [value,side]) {
            state.selected[side] = value
        },
        setCutType (state, payload) {
            state.selected[side] = null
            const {value, side} = payload
            state.wheels[side].data.cutType = value
        },
        setCutWidth (state, payload) {
            const {value, side} = payload
            state.wheels[side].data.cutWidth = value
        },
        setCutHeight (state, payload) {
            const {value, side} = payload
            state.wheels[side].data.cutHeight = value
        },
        setPlus (state, payload) {
            const {value, item, side} = payload
            state.selected[side] = null
            state.wheels[side].data[item] = value
        },
        setPlusEdge (state, payload) {
            const {value, item, side} = payload
            state.wheels[side].data[item] = value
        },
        [setIsActive](state, payload) {
            const {value, side} = payload
            state.wheels[side].isActive = value
        },
        [setWheelDiskType](state, payload) {
            const {value, side} = payload
            state.wheels[side].data.solidDisk = value
        },
        [setIsRunflat](state, payload) {
            const {value, side} = payload
            state.wheels[side].data.isRunflat = value
        },
        changePatch (state, payload) {
            const {value, side} = payload
            state.wheels[side].data.PatchType = value.PatchType
            state.wheels[side].data.PatchPrice = value.PatchPrice
            state.wheels[side].data.PatchSelected = value.PatchSelected
            state.wheels[side].data.time_cold = value.time_cold
            state.wheels[side].data.time_hot = value.time_hot
        },
        setTyreRepairs (state, value) {
            state.tyreRepairs = [...value]
        },
        setExtraDiameters (state, value) {
            //state.availableTire: [],
            value.forEach((x) => {
                state.availableTire.push(x.radius)
            })
            Object.assign(state.extraDiameters, value)
        },
    },
    actions: {
        async init({ getters, commit, rootState }) {
            let data = {
                radius: parseInt(rootState.clientCard.diskSize.replace('R', '')),
                radiusRate: 0,
                solidDisk: rootState.clientCard.diskType !== "shtamp",
                isRunflat: rootState.clientCard.runflat,
                cutType: 0,
                cutWidth: 0,
                cutHeight: 0,
                PatchType: null,
                PatchPrice: null,
                time_cold: null,
                time_hot: null,
                PatchSelected: {},
                hotVulcan: false,
                edgeRestoration: false,
                cameraRepair: false,
                cameraRepairVol: 1,
                hareness: false,
                harenessVol: 1,
            }
            getters.sides.forEach(side => {
                commit('addData', {side: side.sideName, value: data})
            })
        },
        addExtraPrice ({ getters, commit, state }) {
            getters.sides.forEach(side => {
                if(state.wheels[side.sideName].data.radius > 12){
                    for (let x in state.extraDiameters) {
                        if (state.extraDiameters[x].radius == state.wheels[side.sideName].data.radius) {
                            commit('setRadiusRate', { side: side.sideName, value: state.extraDiameters[x].price})
                        }
                    }
                }
            })
        },
        cutRepairPrice ({ commit, state }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: state.url + 'tyre-repair.json',
                }).then((response) => {
                        console.log('CutRepairPrice:', response.data)
                        commit('setTyreRepairs', response.data.tyreRepairs.sort((a, b) => a.price - b.price ))
                        commit('setExtraDiameters', response.data.extraDiameters)
                        resolve(response.data)
                    }).catch((e) => {
                    reject(e)
                })
            })
        },
        setRadius({state, commit}, payload) {
            const { value, side } = payload
            commit(setRadius, payload)
            if(value > 12){
                for (let x in state.extraDiameters) {
                    console.log(x)
                    if (state.extraDiameters[x].radius === value) {
                        commit('setRadiusRate', { side, value: state.extraDiameters[x].price})
                    }
                }
            } else {
                commit('setRadiusRate', { side, value: 0})
            }
        },
        [changeActiveWheels]({commit}, payload) {
            for (const side in payload) {
                commit(setIsActive, {side, value: payload[side]})
            }
        },
        [changeRadius]({state, commit}, payload) {
            const {side, value} = payload;
            const options = state[side].data.radius.map(option => {
                if (option.value === value) {
                    return {...option, selected: true}
                } else {
                    return {...option, selected: false}
                }
            });
            commit(setRadius, {side, value: options})
        },
        [changeWheelDiskType]({commit}, payload) {
            commit(setWheelDiskType, payload)
        },
        [changeIsRunflat]({commit}, payload) {
            commit(setIsRunflat, payload)
        },
        [changeCutType]({commit}, payload) {
            commit(setCutType, payload)
        },
    },

    getters: {
        sides: state => [
            {...state.forwardLeft, sideName: 'forwardLeft'},
            {...state.forwardRight, sideName: 'forwardRight'},
            {...state.backLeft, sideName: 'backLeft'},
            {...state.backRight, sideName: 'backRight'},
            {...state.spareLeft, sideName: 'spareLeft'},
            {...state.spareRight, sideName: 'spareRight'},
        ],
    },
}
